import { Box, Text, Image } from "@chakra-ui/react";

interface LearnMoreContentProps {
   learnMore: number | any; // This is actually the full learnMore object
}

export default function LearnMoreContent({ learnMore }: LearnMoreContentProps) {
   // The learnMoreId prop is actually the full learnMore object
   console.log("learnMore", learnMore);
   if (!learnMore) {
      return null;
   }

   // If learnMore is just a string, render it directly
   if (typeof learnMore === "string") {
      return (
         <Box whiteSpace="pre-wrap">
            <Text>{learnMore}</Text>
         </Box>
      );
   }

   // If it's an array (old format), render the list
   if (Array.isArray(learnMore)) {
      return (
         <Box>
            {learnMore.map((item, index) => (
               <Text key={index} mb={2}>
                  {item}
               </Text>
            ))}
         </Box>
      );
   }

   // If it's an object with content property (new format)
   if (learnMore.content) {
      return (
         <Box>
            {learnMore.image && (
               <Box mb={4}>
                  <Image
                     src={learnMore.image.url}
                     alt={learnMore.image.title || "Product information"}
                     objectFit="contain"
                     maxH="300px"
                     mx="auto"
                  />
               </Box>
            )}

            <Box whiteSpace="pre-wrap">
               {learnMore.content.split("\n").map((paragraph, idx) => (
                  <Text key={idx} mb={3}>
                     {paragraph}
                  </Text>
               ))}
            </Box>
         </Box>
      );
   }

   // Fallback for any other format
   return (
      <Box>
         <Text>{JSON.stringify(learnMore)}</Text>
      </Box>
   );
}
